<template>
  <AppHeader />

  <main class="app-main">
    <router-view />
  </main>

  <SiteFooter />
  <SupportFab />
</template>

<script>
import AppHeader from "@/components/AppHeader.vue";
import SiteFooter from "@/components/SiteFooter.vue";
import SupportFab from "@/components/SupportFab.vue";
import { DR_APP_NAME } from "../appName";

export default {
  name: "App",
  components: { AppHeader, SiteFooter, SupportFab },
  data() {
    return { observer: null };
  },
  mounted() {
    document.title = DR_APP_NAME;

    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (reduce) {
      document.querySelectorAll(".reveal").forEach((el) => el.classList.add("is-visible"));
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            this.observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    );

    this.observeReveal();
    this.$router.afterEach(() => {
      this.$nextTick(this.observeReveal);
    });
  },
  beforeUnmount() {
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    observeReveal() {
      if (!this.observer) return;
      document
        .querySelectorAll(".reveal:not(.is-visible)")
        .forEach((el) => this.observer.observe(el));
    }
  }
};
</script>

<style>
.app-main {
  padding-top: 0;
}
</style>
